<template>
  <footer class="bg-gray-900 text-white py-12">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="grid md:grid-cols-4 gap-8">
        <div>
          <!-- <h3 class="text-2xl font-bold mb-4">AMGO</h3> -->
          <img src="/assets/logo.png" alt="AMGO" class="h-20 mb-2" />
          <p class="text-gray-400 mb-4">
            Association des Médecins Généralistes d'Oran - Promouvoir
            l'excellence médicale et renforcer la solidarité professionnelle des
            médecins de famille.
          </p>
          <div class="flex space-x-4">
            <a
              href="https://web.facebook.com/AMGO31DZ?_rdc=1"
              target="_blank"
              class="text-gray-400 hover:text-white transition-colors mt-1"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <title>Facebook</title>
                <path
                  d="M22.675 0H1.325C0.593 0 0 .593 0 1.325v21.351C0 
  23.407.593 24 1.325 24H12.82v-9.294H9.692V11.02h3.128V8.413c0-3.1 
  1.893-4.788 4.659-4.788 1.325 0 2.463.099 
  2.795.143v3.24l-1.918.001c-1.504 
  0-1.796.715-1.796 1.763v2.313h3.587l-.467 
  3.686h-3.12V24h6.116c.732 0 1.325-.593 
  1.325-1.324V1.325C24 .593 23.407 0 
  22.675 0z"
                />
              </svg>
            </a>
            <a
              href="https://www.instagram.com/amgo.dz/"
              target="_blank"
              class="text-gray-400 hover:text-white transition-colors"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <title>Instagram</title>
                <path
                  d="M12 2.163c3.204 0 3.584.012 4.85.07 1.17.056 1.97.24 2.427.403a4.9 4.9 0 0 1 1.675 1.092 4.9 4.9 0 0 1 1.092 1.675c.163.457.347 1.257.403 2.427.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.056 1.17-.24 1.97-.403 2.427a4.9 4.9 0 0 1-1.092 1.675 4.9 4.9 0 0 1-1.675 1.092c-.457.163-1.257.347-2.427.403-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.17-.056-1.97-.24-2.427-.403a4.9 4.9 0 0 1-1.675-1.092 4.9 4.9 0 0 1-1.092-1.675c-.163-.457-.347-1.257-.403-2.427C2.175 15.747 2.163 15.367 2.163 12s.012-3.584.07-4.85c.056-1.17.24-1.97.403-2.427a4.9 4.9 0 0 1 1.092-1.675 4.9 4.9 0 0 1 1.675-1.092c.457-.163 1.257-.347 2.427-.403C8.416 2.175 8.796 2.163 12 2.163Zm0 1.84c-3.163 0-3.532.012-4.776.07-1.022.047-1.577.217-1.944.362-.49.19-.84.417-1.208.785a3.06 3.06 0 0 0-.785 1.208c-.145.367-.315.922-.362 1.944-.058 1.244-.07 1.613-.07 4.776s.012 3.532.07 4.776c.047 1.022.217 1.577.362 1.944.19.49.417.84.785 1.208.368.368.718.595 1.208.785.367.145.922.315 1.944.362 1.244.058 1.613.07 4.776.07s3.532-.012 4.776-.07c1.022-.047 1.577-.217 1.944-.362.49-.19.84-.417 1.208-.785.368-.368.595-.718.785-1.208.145-.367.315-.922.362-1.944.058-1.244.07-1.613.07-4.776s-.012-3.532-.07-4.776c-.047-1.022-.217-1.577-.362-1.944a3.06 3.06 0 0 0-.785-1.208 3.06 3.06 0 0 0-1.208-.785c-.367-.145-.922-.315-1.944-.362-1.244-.058-1.613-.07-4.776-.07Zm0 3.905a5.092 5.092 0 1 1 0 10.183 5.092 5.092 0 0 1 0-10.183Zm0 8.396a3.304 3.304 0 1 0 0-6.609 3.304 3.304 0 0 0 0 6.609Zm5.338-9.63a1.19 1.19 0 1 1 0-2.381 1.19 1.19 0 0 1 0 2.381Z"
                />
              </svg>
            </a>
            <a
              href="https://www.youtube.com/@amgo31dz"
              target="_blank"
              class="text-gray-400 hover:text-white transition-colors"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <title>YouTube</title>
                <path
                  d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.016 3.016 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.016 3.016 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814ZM9.546 15.568V8.432L15.818 12l-6.272 3.568Z"
                />
              </svg>
            </a>
          </div>
        </div>

        <div>
          <h4 class="text-lg font-semibold mb-4">Navigation</h4>
          <ul class="space-y-2">
            <li>
              <a
                href="/#accueil"
                class="text-gray-400 hover:text-white transition-colors"
                >Accueil</a
              >
            </li>
            <li>
              <a
                href="/#a_propos"
                class="text-gray-400 hover:text-white transition-colors"
                >À propos</a
              >
            </li>
            <li>
              <a
                href="/#nosobjectifs"
                class="text-gray-400 hover:text-white transition-colors"
                >Activités</a
              >
            </li>
            <li>
              <a
                href="/#actualitees"
                class="text-gray-400 hover:text-white transition-colors"
                >Actualités</a
              >
            </li>
            <li>
              <a
                href="/#nousrejoindre"
                class="text-gray-400 hover:text-white transition-colors"
                >Contact</a
              >
            </li>
          </ul>
        </div>

        <div>
          <h4 class="text-lg font-semibold mb-4">Nos Objectifs</h4>
          <ul class="space-y-2">
            <li>
              <a
                href="/#FormationContinue"
                class="text-gray-400 hover:text-white transition-colors"
                >Formation Continue</a
              >
            </li>
            <li>
              <a
                href="/#RechercheMedicale"
                class="text-gray-400 hover:text-white transition-colors"
                >Recherche Médicale</a
              >
            </li>
            <li>
              <a
                href="/#EngagementCommunautaire"
                class="text-gray-400 hover:text-white transition-colors"
                >Engagement Communautaire</a
              >
            </li>
            <li>
              <a
                href="/#SolidariteProfessionnelle"
                class="text-gray-400 hover:text-white transition-colors"
                >Solidarité Professionnelle</a
              >
            </li>
            <li>
              <a
                href="/#ExcellenceMedicale"
                class="text-gray-400 hover:text-white transition-colors"
                >Excellence Médicale</a
              >
            </li>
          </ul>
        </div>

        <div>
          <h4 class="text-lg font-semibold mb-4">Contact</h4>
          <div class="space-y-2 text-gray-400">
            <p>
              31, Rue 1er Novembre<br />Bir El Djir - Oran<br />BR52-RP-31000 -
              Algérie
            </p>
            <p>0671 15 32 16</p>
            <p>contact@amgoran.dz</p>
          </div>
        </div>
      </div>
      <div class="border-t border-gray-800 mt-8 pt-0">
        <div
          class="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0"
          style="background-color: #2a2e2e"
        >
          <p class="text-gray-400">
            &copy; 2025 Association AMGO. Tous droits réservés.
          </p>
          <div
            class="flex flex-wrap justify-center md:justify-end space-x-6 text-sm"
          >
            <a
              href="/legal-notices"
              class="text-gray-400 hover:text-white transition-colors"
              >Mentions légales</a
            >
            <a
              href="/politique-confidentialites"
              class="text-gray-400 hover:text-white transition-colors"
              >Politique de confidentialité</a
            >
            <a
              href="/cookies"
              class="text-gray-400 hover:text-white transition-colors"
              >Cookies</a
            >
          </div>
        </div>
      </div>

      <div class="border-t border-gray-800 mt-0 pt-0 text-left text-white">
        <p>
          &nbsp;<a
            href="https://213devops.com"
            target="_blank"
            style="text-decoration: underline; font-size: smaller"
          >
            Création SPAS Algérie DEVOPS</a
          >
        </p>
      </div>
      &nbsp;
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  props: {},
};
</script>

<style scoped></style>
